import React from "react";
import Bookmark from "../documentCard/Bookmark";
import { Tooltip } from "@chakra-ui/react";

const OnlineStatusIcon = () => {
	return (
		<svg
			cursor="pointer"
			width="15"
			height="15"
			viewBox="0 0 10 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="5" cy="5" r="5" fill="#00AE00" />
		</svg>
	);
};

const EyeIcon = () => {
	return (
		<svg
			width="30"
			cursor="pointer"
			height="30"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g opacity="0.5">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M9.99998 3.75C5.83331 3.75 2.27498 6.34167 0.833313 10C2.27498
                      13.6583 5.83331 16.25 9.99998 16.25C14.1666 16.25 17.725 13.6583 19.1666
                      10C17.725 6.34167 14.1666 3.75 9.99998 3.75ZM9.99998 14.1667C7.69998 14.1667
                      5.83331 12.3 5.83331 10C5.83331 7.7 7.69998 5.83333 9.99998 5.83333C12.3 5.83333
                      14.1666 7.7 14.1666 10C14.1666 12.3 12.3 14.1667 9.99998 14.1667ZM7.49998 10C7.49998
                      8.61667 8.61665 7.5 9.99998 7.5C11.3833 7.5 12.5 8.61667 12.5 10C12.5 11.3833 11.3833
                      12.5 9.99998 12.5C8.61665 12.5 7.49998 11.3833 7.49998 10Z"
					fill="#002B49"
				/>
			</g>
		</svg>
	);
};

const HamburgerMenuIcon = () => {
	return (
		<svg
			width="6"
			cursor="pointer"
			height="21"
			viewBox="0 0 4 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g opacity="0.5">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1.99998 3.66668C2.91665 3.66668 3.66665
					  2.91668 3.66665 2.00001C3.66665 1.08334 2.91665 0.333344
					  1.99998 0.333344C1.08331 0.333344 0.333313 1.08334 0.333313
					  2.00001C0.333313 2.91668 1.08331 3.66668 1.99998 3.66668ZM1.99998
					  5.33334C1.08331 5.33334 0.333313 6.08334 0.333313 7.00001C0.333313
					  7.91668 1.08331 8.66668 1.99998 8.66668C2.91665 8.66668 3.66665 7.91668
					  3.66665 7.00001C3.66665 6.08334 2.91665 5.33334 1.99998 5.33334ZM0.333313
					  12C0.333313 11.0833 1.08331 10.3333 1.99998 10.3333C2.91665 10.3333 3.66665
					  11.0833 3.66665 12C3.66665 12.9167 2.91665 13.6667 1.99998 13.6667C1.08331
					  13.6667 0.333313 12.9167 0.333313 12Z"
					fill="#002B49"
				/>
			</g>
		</svg>
	);
};

type IconProps = {
	color?: string;
};

/**
 *  Creates a type of bookmark that can be placed on a document card
 *
 * @param props Properties of the bookmark that can be changed on usage
 */
const BookmarkIcon = ({ color }: IconProps) => {
	return (
		<Tooltip label="View analytics" backgroundColor="grey">
			<svg
				width="37"
				height="61"
				viewBox="0 0 37 61"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g filter="url(#filter0_d_2_455)">
					<rect
						x="4"
						y="-5"
						width="33"
						height="58"
						fill={color || "grey"}
					/>
				</g>
				<path
					d="M30 17.25L24.6585 21.9238C24.2815 22.2537 23.7185 22.2537 23.3415 21.9238L21.6585 20.4512C21.2815 20.1213 20.7185 20.1213 20.3415 20.4512L16 24.25"
					stroke="white"
					stroke-opacity="0.45"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M12 14.625V27.175C12 28.2951 12 28.8552 12.218 29.283C12.4097 29.6593 12.7157 29.9653 13.092 30.157C13.5198 30.375 14.0799 30.375 15.2 30.375H30"
					stroke="white"
					stroke-opacity="0.45"
					stroke-width="2"
					stroke-linecap="round"
				/>
				<defs>
					<filter
						id="filter0_d_2_455"
						x="0"
						y="-5"
						width="41"
						height="66"
						filterUnits="userSpaceOnUse"
						color-interpolation-filters="sRGB"
					>
						<feFlood
							flood-opacity="0"
							result="BackgroundImageFix"
						/>
						<feColorMatrix
							in="SourceAlpha"
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha"
						/>
						<feOffset dy="4" />
						<feGaussianBlur stdDeviation="2" />
						<feComposite in2="hardAlpha" operator="out" />
						<feColorMatrix
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
						/>
						<feBlend
							mode="normal"
							in2="BackgroundImageFix"
							result="effect1_dropShadow_2_455"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_dropShadow_2_455"
							result="shape"
						/>
					</filter>
				</defs>
			</svg>
		</Tooltip>
	);
};

const WhitePenIcon = () => {
	return (
		<svg
			stroke="currentColor"
			fill="currentColor"
			stroke-width="0"
			viewBox="0 0 24 24"
			data-testid="dashboard.projects.projectDetail.nameEditIcon"
			className="icon__Icon-zowch7-0 jBhaMQ"
			height="22px"
			width="22px"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path>
		</svg>
	);
};

const FolderIcon = () => {
	return (
		<svg
			width="158"
			height="120"
			viewBox="0 0 158 120"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g filter="url(#filter0_d_233_5993)">
				<path
					d="M4 13C4 7.47715 8.47715 3 14 3H58.5612L68.9864 16.4164C69.1758 16.6602 69.4672 16.8028 69.776 16.8028H144C149.523 16.8028 154 21.28 154 26.8028V105C154 110.523 149.523 115 144 115H14C8.47715 115 4 110.523 4 105V13Z"
					fill="white"
				/>
				<path
					d="M4.5 13C4.5 7.7533 8.7533 3.5 14 3.5H58.3165L68.5915 16.7232C68.8757 17.0889 69.3129 17.3028 69.776 17.3028H144C149.247 17.3028 153.5 21.5561 153.5 26.8028V105C153.5 110.247 149.247 114.5 144 114.5H14C8.75329 114.5 4.5 110.247 4.5 105V13Z"
					stroke="white"
				/>
			</g>
			<defs>
				<filter
					id="filter0_d_233_5993"
					x="0"
					y="0"
					width="158"
					height="120"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="1" />
					<feGaussianBlur stdDeviation="2" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0668025 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_233_5993"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_233_5993"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
};

const SettingsIcon = () => {
	return (
		<svg
			stroke="currentColor"
			fill="currentColor"
			stroke-width="0"
			viewBox="0 0 24 24"
			height="20"
			width="20"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"></path>
		</svg>
	);
};

const PenIcon = () => {
	return (
		<svg
			width="30"
			cursor="pointer"
			height="30"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g opacity="0.5">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M17.2583 4.69167C17.5833 5.01667 17.5833 5.54167 17.2583 5.86667L15.7333 7.39167L12.6083 4.26667L14.1333 2.74167C14.4583 2.41667 14.9833 2.41667 15.3083 2.74167L17.2583 4.69167ZM2.5 17.5V14.375L11.7167 5.15834L14.8417 8.28334L5.625 17.5H2.5Z"
					fill="#002B49"
				/>
			</g>
		</svg>
	);
};

export enum IconType {
	PEN,
	WHITE_PEN,
	ONLINE_STATUS,
	HAMBURGER_MENU,
	EYE_ICON,
	SETTINGS,
	FOLDER,
	BOOKMARK,
}

type FoleonIconProps = IconProps & {
	iconType: IconType;
};

export const FoleonIcon = ({ iconType, color }: FoleonIconProps) => {
	switch (iconType) {
		case IconType.WHITE_PEN:
			return <WhitePenIcon />;
		case IconType.PEN:
			return <PenIcon />;
		case IconType.EYE_ICON:
			return <EyeIcon />;
		case IconType.HAMBURGER_MENU:
			return <HamburgerMenuIcon />;
		case IconType.ONLINE_STATUS:
			return <OnlineStatusIcon />;
		case IconType.FOLDER:
			return <FolderIcon />;
		case IconType.SETTINGS:
			return <SettingsIcon />;
		case IconType.BOOKMARK:
			return <BookmarkIcon color={color} />;
	}
};
